import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, IconButton, List } from '@mui/material';
import { CharacterListEntry } from '@datapad/common-controls';
import { createReferenceToNode } from '@datapad/data-model';
import { Star, StarBorder } from '@mui/icons-material';
export function CharacterList(props) {
    const { characters, defaultCharacterId, changeDefaultCharacter, onClick, button, dense } = props;
    return (_jsx(List, { children: characters.map((character) => {
            const isDefault = defaultCharacterId === character.id;
            return (_jsxs(Box, { display: "flex", flexDirection: "row", children: [_jsx(IconButton, { onClick: isDefault
                            ? () => changeDefaultCharacter(undefined)
                            : () => changeDefaultCharacter(createReferenceToNode(character)), children: isDefault ? _jsx(Star, {}) : _jsx(StarBorder, {}) }), _jsx(CharacterListEntry, { character: character, onClick: () => onClick?.(character), button: button, dense: dense })] }, character.id));
        }) }));
}
//# sourceMappingURL=CharacterList.js.map